import { defaultBorderRadius, defaultTypography } from './defaults'
import type { Typography } from './defaults'
import { palette as darkPalette } from './param-dark-palette'
import { palette as lightPalette } from './param-palette'

// Frozen web-app baseline: c195378a49b5409f735d3a38ad23d92ba76d7ecb.
// Tokens without a historical equivalent retain the modern foundation.
export const legacyLightPalette = {
  ...lightPalette,
  icons: { ...lightPalette.icons, main: '#766478' },
  overlay: { ...lightPalette.overlay, main: '#9c919e' },
  tertiary: { ...lightPalette.tertiary, upperMediumContrast: '#766478' },
  secondary: { ...lightPalette.secondary, mainContrast: '#00a5a1', maxContrast: '#55cfcc' },
  success: { ...lightPalette.success, mediumContrast: '#a0ad97', lowContrast: '#edfff0' },
  warning: { ...lightPalette.warning, mediumContrast: '#f0c493' },
  text: { ...lightPalette.text, description: '#766478', caption: '#9c919e', disabled: '#9c919e' },
}

export const legacyDarkPalette = {
  ...darkPalette,
  disabled: { ...darkPalette.disabled, main: '#928F8F1E' },
  ghost: { ...darkPalette.ghost, lowContrast: '#918E8E1F' },
  overlay: { ...darkPalette.overlay, main: '#918E8E1F' },
  tertiary: { ...darkPalette.tertiary, lowContrast: '#918E8E1F' },
  secondary: { ...darkPalette.secondary, mainContrast: '#00b7b3', maxContrast: '#019693' },
  category: lightPalette.category,
}

export const legacyBorderRadius = {
  ...defaultBorderRadius,
  xs: '2px',
  sm: '4px',
  md: '8px',
  lg: '16px',
  xl: '24px',
  xxl: '48px',
}

export const legacyTypography: Typography = {
  ...defaultTypography,
  variants: {
    h1: { fontSize: '2rem', lineHeight: '2.75rem', letterSpacing: '-1px' },
    h1Mobile: { fontSize: '1.75rem', lineHeight: '2rem', letterSpacing: '0.02em' },
    h2: { fontSize: '1.625rem', lineHeight: '2.25rem', letterSpacing: '-1px', mobileLetterSpacing: '0.02em' },
    h3: { fontSize: '1.3125rem', lineHeight: '1.5rem', letterSpacing: '0.42px' },
    b1: { fontSize: '1.125rem', lineHeight: '1.625rem', letterSpacing: '-0.4px', mobileLetterSpacing: '0.01em' },
    b2: { fontSize: '1.0625rem', lineHeight: '1.5rem', letterSpacing: '-0.4px' },
    b3: { fontSize: '0.875rem', lineHeight: '1.375rem', letterSpacing: '-0.3px' },
    b4: { fontSize: '0.8125rem', lineHeight: '1.125rem', letterSpacing: '-0.3px' },
    b5: { fontSize: '0.6875rem', lineHeight: '1rem', letterSpacing: '-0.3px' },
    bodyMedium: { fontSize: '1.0625rem', lineHeight: '1.625rem', letterSpacing: '0.01em' },
    bodySmall: { fontSize: '1.0625rem', lineHeight: '1.625rem', letterSpacing: '0.01em' },
    bodyMediumMobile: { fontSize: '0.9375rem', lineHeight: '1.25rem', letterSpacing: '0.01em' },
  },
}
